class Lp4rwReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-reviews-track]');
    this.prevButton = this.querySelector('[data-reviews-prev]');
    this.nextButton = this.querySelector('[data-reviews-next]');
    if (!this.track || !this.prevButton || !this.nextButton) return;

    this.prevButton.addEventListener('click', this.handlePrev);
    this.nextButton.addEventListener('click', this.handleNext);
    this.track.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll);
    this.updateButtons();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.handlePrev);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.track?.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }

  get step() {
    const card = this.track.querySelector('[data-reviews-card]');
    if (!card) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  scrollByStep(direction) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: direction * this.step, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  handlePrev = () => this.scrollByStep(-1);

  handleNext = () => this.scrollByStep(1);

  handleScroll = () => {
    if (this.rafId) return;
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      this.updateButtons();
    });
  };

  updateButtons = () => {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    this.prevButton.disabled = this.track.scrollLeft <= 0;
    this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
  };
}

if (!customElements.get('lp-4rw-reviews-carousel')) {
  customElements.define('lp-4rw-reviews-carousel', Lp4rwReviewsCarousel);
}
